export const REDO_EMAIL_DOMAINS = ["getredo.com", "redo.com"];

export const isRedoEmailAddress = (
  email: string | null | undefined,
): boolean => {
  const emailNormalized = email?.toLowerCase().trim();
  if (!emailNormalized) {
    return false;
  }

  const [localPart, domain, extraPart] = emailNormalized.split("@");
  if (!localPart || !domain || extraPart != null) {
    return false;
  }

  return REDO_EMAIL_DOMAINS.includes(domain);
};

/**
 * Candidate emails to try when resolving a Redo person by address (e.g. a Slack
 * `users.lookupByEmail`): the original plus the same local part on each other
 * Redo domain, since someone's SSO login domain (e.g. @getredo.com) may differ
 * from their Slack profile email (e.g. @redo.com). Non-Redo emails return only
 * themselves. Original is always first.
 */
export const redoEmailVariants = (email: string): string[] => {
  const normalized = email.toLowerCase().trim();
  const [localPart, domain, extraPart] = normalized.split("@");
  if (!localPart || !domain || extraPart != null) {
    return [normalized];
  }
  if (!REDO_EMAIL_DOMAINS.includes(domain)) {
    return [normalized];
  }
  const variants = [normalized];
  for (const redoDomain of REDO_EMAIL_DOMAINS) {
    const candidate = `${localPart}@${redoDomain}`;
    if (!variants.includes(candidate)) {
      variants.push(candidate);
    }
  }
  return variants;
};
